module.exports = __webpack_public_path__ + "static/media/1016938.e9a5223c.jpg";